"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOOL_SUBMIT = exports.TOOL_STEP = exports.TOOL_START = exports.TOOL_ERROR = exports.TOOL_COMPLETE = exports.SHARE_CLICKS = exports.SEARCH_REFINEMENT = exports.SEARCH = exports.REMOVE_FROM_CART = exports.PRODUCT_IMPRESSIONS = exports.PRODUCT_CART_VIEWS = exports.PAGE_LOADED = exports.LOGIN_START = exports.LOGIN_COMPLETE = exports.LINK_CLICKS = exports.FORM_START = exports.FORM_COMPLETE = exports.EXIT_CLICKS = exports.ERROR_EVENT = exports.DOWNLOAD_CLICKS = exports.CHAT_RETURN = exports.CHAT_RESPONSE = exports.CHAT_REQUEST = exports.CHAT_OFFERED = exports.CHAT_MINIMIZED = exports.CHAT_INITIATED = exports.CHAT_FAILURE = exports.CHAT_END = exports.CHAT_DECLINED = exports.CHAT_COMPLETED = exports.CHAT_CLOSE = exports.CHAT_CLICKED = exports.CHAT_CANCELLED = exports.ADD_TO_CART = void 0;
var ADD_TO_CART = 'addToCart';
exports.ADD_TO_CART = ADD_TO_CART;
var CHAT_CANCELLED = 'chatCancelled';
exports.CHAT_CANCELLED = CHAT_CANCELLED;
var CHAT_CLICKED = 'chatClicked';
exports.CHAT_CLICKED = CHAT_CLICKED;
var CHAT_CLOSE = 'chatClose';
exports.CHAT_CLOSE = CHAT_CLOSE;
var CHAT_COMPLETED = 'chatCompleted';
exports.CHAT_COMPLETED = CHAT_COMPLETED;
var CHAT_DECLINED = 'chatDeclined';
exports.CHAT_DECLINED = CHAT_DECLINED;
var CHAT_END = 'chatEnd';
exports.CHAT_END = CHAT_END;
var CHAT_FAILURE = 'chatFailure';
exports.CHAT_FAILURE = CHAT_FAILURE;
var CHAT_INITIATED = 'chatInitiated';
exports.CHAT_INITIATED = CHAT_INITIATED;
var CHAT_MINIMIZED = 'chatMinimized';
exports.CHAT_MINIMIZED = CHAT_MINIMIZED;
var CHAT_OFFERED = 'chatOffered';
exports.CHAT_OFFERED = CHAT_OFFERED;
var CHAT_REQUEST = 'chatRequest';
exports.CHAT_REQUEST = CHAT_REQUEST;
var CHAT_RESPONSE = 'chatResponse';
exports.CHAT_RESPONSE = CHAT_RESPONSE;
var CHAT_RETURN = 'chatReturn';
exports.CHAT_RETURN = CHAT_RETURN;
var DOWNLOAD_CLICKS = 'downloadClicks';
exports.DOWNLOAD_CLICKS = DOWNLOAD_CLICKS;
var ERROR_EVENT = 'errorEvent';
exports.ERROR_EVENT = ERROR_EVENT;
var EXIT_CLICKS = 'exitClicks';
exports.EXIT_CLICKS = EXIT_CLICKS;
var FORM_COMPLETE = 'formComplete';
exports.FORM_COMPLETE = FORM_COMPLETE;
var FORM_START = 'formStart';
exports.FORM_START = FORM_START;
var LINK_CLICKS = 'linkClicks';
exports.LINK_CLICKS = LINK_CLICKS;
var LOGIN_COMPLETE = 'loginComplete';
exports.LOGIN_COMPLETE = LOGIN_COMPLETE;
var LOGIN_START = 'loginStart';
exports.LOGIN_START = LOGIN_START;
var PAGE_LOADED = 'pageLoaded';
exports.PAGE_LOADED = PAGE_LOADED;
var PRODUCT_CART_VIEWS = 'productCartViews';
exports.PRODUCT_CART_VIEWS = PRODUCT_CART_VIEWS;
var PRODUCT_IMPRESSIONS = 'productImpressions';
exports.PRODUCT_IMPRESSIONS = PRODUCT_IMPRESSIONS;
var REMOVE_FROM_CART = 'removeFromCart';
exports.REMOVE_FROM_CART = REMOVE_FROM_CART;
var SEARCH = 'search';
exports.SEARCH = SEARCH;
var SEARCH_REFINEMENT = 'searchRefinement';
exports.SEARCH_REFINEMENT = SEARCH_REFINEMENT;
var SHARE_CLICKS = 'shareClicks';
exports.SHARE_CLICKS = SHARE_CLICKS;
var TOOL_COMPLETE = 'toolComplete';
exports.TOOL_COMPLETE = TOOL_COMPLETE;
var TOOL_ERROR = 'toolError';
exports.TOOL_ERROR = TOOL_ERROR;
var TOOL_START = 'toolStart';
exports.TOOL_START = TOOL_START;
var TOOL_STEP = 'toolStep';
exports.TOOL_STEP = TOOL_STEP;
var TOOL_SUBMIT = 'toolSubmit';
exports.TOOL_SUBMIT = TOOL_SUBMIT;